import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

const METRICS = [
  { prefix: "mais de ", value: 50, suffix: "%", label: "Redução no investimento", sub: "Economia direta na aquisição de novos carrinhos" },
  { prefix: "", value: 24, suffix: "/7", label: "Monitoramento ativo", sub: "Supervisão constante dos perímetros estratégicos" },
  { prefix: "", value: 100, suffix: "%", label: "Abrangência nacional", sub: "Atendimento em todo o território brasileiro" },
  { prefix: "", value: 0, suffix: "", staticText: "0", label: "Carrinho perdido", sub: "Nossa meta: nenhum ativo fora do seu pátio" },
];

const Counter = ({ prefix, value, suffix, staticText }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-60px" });
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    if (!inView || staticText !== undefined) return;
    const controls = animate(0, value, {
      duration: 1.8,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setDisplay(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, value, staticText]);

  return (
    <span ref={ref} className="font-display text-5xl font-black tracking-tight text-slate-50 sm:text-6xl">
      {prefix}
      {staticText !== undefined ? staticText : display}
      <span className="text-[#A3E635]">{suffix}</span>
    </span>
  );
};

export const Stats = () => (
  <section id="impacto" className="relative py-24 sm:py-32" data-testid="stats-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mb-16 max-w-2xl"
      >
        <p className="font-tech text-xs font-bold uppercase tracking-[0.25em] text-[#A3E635]">Impacto medido</p>
        <h2 className="font-display mt-4 text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl">
          Cada carrinho recuperado é dinheiro de volta no seu caixa.
        </h2>
      </motion.div>

      <div className="grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {METRICS.map((m, i) => (
          <motion.div
            key={m.label}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
            className="group bg-[#1E3A8A] p-8 transition-colors duration-300 hover:bg-[#1B3579]"
            data-testid={`stat-card-${i}`}
          >
            <Counter {...m} />
            <p className="mt-4 font-tech text-[11px] font-bold uppercase tracking-[0.2em] text-slate-200">{m.label}</p>
            <p className="mt-2 text-sm leading-relaxed text-slate-400">{m.sub}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Stats;
